import React from "react";
import { Grid } from "@material-ui/core";

import { determineFieldType } from "../lineItemManagement";
import CalcIconBlue from "../../../calcIconBlue.svg";

import {
  FieldWrapper,
  FieldLeftContentWrapper,
  FieldIconWrapper,
  FieldNameTypeWrapper,
  FieldNameWrapper,
  Row,
  FieldRightContentWrapper,
  FieldTypeWrapper,
  StyledSelectButton
} from "./styles";

const FieldListItem = props => {
  const { field, onSelectedField, isSelected, propertyIdSelected } = props;

  if (!propertyIdSelected || (propertyIdSelected && (field.propertyId === -1 || field.propertyId === propertyIdSelected))) {
    return (
      <div>
        <Row>
          <Grid container>
            <FieldWrapper>
              <FieldLeftContentWrapper>
                <FieldIconWrapper>
                  <img src={CalcIconBlue} alt="Calc Icon" height={24} width={24} />
                </FieldIconWrapper>
                <FieldNameTypeWrapper>
                  <FieldNameWrapper>{field.name}</FieldNameWrapper>
                  <FieldTypeWrapper>{determineFieldType(field)}</FieldTypeWrapper>
                </FieldNameTypeWrapper>
              </FieldLeftContentWrapper>
              <FieldRightContentWrapper>
                <StyledSelectButton label={isSelected ? "Selected" : "Select"} onClick={() => onSelectedField(field)} isSelected={isSelected} />
              </FieldRightContentWrapper>
            </FieldWrapper>
          </Grid>
        </Row>
      </div>
    );
  }

  return null;
};

export default FieldListItem;
